import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=d66f90c6&scoped=true&lang=pug"
import script from "./PushNotification.vue?vue&type=script&lang=js"
export * from "./PushNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66f90c6",
  null
  
)

export default component.exports